import React from 'react'
import { EnumUserQuestionsData } from 'types/enums.options'
import { getUserQuestionsEnum } from '_services/enums.service'
import { useFetchV2 } from '../../../../_core/hooks'
import { Dropdown } from 'primereact/dropdown'
import { UserQuestionResponse } from 'types/user'
import Skeleton from '../../../../components/skeleton'

type Value = Omit<UserQuestionResponse,'toQuestion' | 'userId'>

type QuestionsInputProps = {
  value:Value[]
  onChange:(_:Value[]) => void
}

const QuestionsInput = (props:QuestionsInputProps) => {
  const [questions,_] = useFetchV2<EnumUserQuestionsData[],undefined>(getUserQuestionsEnum,undefined,[])

  return (
    <Skeleton dependency={questions}>
      {(questions) => <>{questions.map((x) =>
        <div key={x.id} className="d-flex flex-column gap-2">
          <label htmlFor={x.id}>{x.question}</label>
          <Dropdown
            id={x.id}
            name={x.id}
            options={x.options.sort((a,b) => a.sort - b.sort)}
            optionLabel="display"
            optionValue="id"
            value={props.value.find(y => y.questionId == x.id)?.questionOptionId || ''}
            onChange={(e) => {
              props.onChange(
                props.value.map((x) => x.questionId).includes(e.target.name)
                ? props.value.map((y) => y.questionId === x.id ? { ...y,'questionOptionId':e.target.value } : y)
                : [...props.value,{ 'questionId':e.target.name,'questionOptionId':e.target.value }]
              )
            }}
          />
        </div>
      )}</>}
    </Skeleton>
  )
}

export default React.memo(QuestionsInput)
